import React, { createContext, useState, useContext } from "react";

interface EmailActionContextType {
  elementId: any;
  setElementId: (elementId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
}

export const EmailActionContext = createContext<EmailActionContextType>({
  elementId: null,
  setElementId: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
});

interface EmailActionProviderProps {
  children: React.ReactNode;
}

export const EmailActionProvider: React.FC<EmailActionProviderProps> = ({
  children,
}) => {
  const [elementId, setElementId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);

  const value = {
    elementId,
    setElementId,
    showModal,
    setShowModal,    
    backendFormErrors,
    setBackendFormErrors,
  };
  return (
    <EmailActionContext.Provider value={value}>
      {children}
    </EmailActionContext.Provider>
  );
};
